<template>
  <div>
    <v-tabs light>
        <v-tabs-slider color="light-blue lighten-2"></v-tabs-slider>
        <v-tab href="#tab-1">Show My Login User Profile</v-tab>
        <v-tab href="#tab-2">Edit My Login User Profile</v-tab>
        <v-tab href="#tab-3">Change My Password</v-tab>
        <v-tab-item :id="'tab-1'">
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field box label="Login Email Address" v-model="user.loginEmailAddress"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Status" v-model="user.userStatus"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="First Name" v-model="user.firstName"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Last Name" v-model="user.lastName"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Phone Number" v-model="phonenum"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Page Number" v-model="pagernum"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Care Group" v-model="groupname"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Account Type" v-model="accttype"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field box label="Last Longin At" v-model="user.lastLoginAt"></v-text-field>
            </v-flex>
          </v-layout>
        </v-tab-item>
        <v-tab-item :id="'tab-2'">
          <v-card flat>
            <v-card-text class="text-xs-left">
              To Edit Login User Profile Details
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :id="'tab-3'">
        <v-form v-model="valid">
          <v-card>
            <v-card-text>
              <v-text-field
                name="oldpassword"
                label="Old Password"
                v-model="oldpassword"
                type="password"
                hint="Please enter old password here"
                :rules="[() => oldpassword.length > 0 || 'This field is required']"
                required>
              </v-text-field>
              <v-text-field
                name="newpassword"
                label="New Password"
                v-model="newpassword"
                type="password"
                hint="Please enter your password here"
                :rules="[() => newpassword.length > 0 || 'This field is required']"
                required>
              </v-text-field>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                v-model="confirmPassword"
                type="password"
                hint="Please re-enter password here"
                :rules="[comparePasswords]">
              </v-text-field>
              <small>*indicates required field</small>
              <br>
              <div class="red--text" v-html="error"></div>
              <br>
              <v-btn @click="chgpwd" :disabled="!isComplete">Save Change</v-btn>
            </v-card-text>
          </v-card>
        </v-form>
        </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import mixins from '@/mixins.js'
import LoginUserService from '@/services/LoginUserService'

export default {
  data () {
    return {
      groupname: '',
      accttype: '',
      phonenum: '',
      pagernum: '',
      oldpassword: '',
      newpassword: '',
      confirmPassword: '',
      valid: false,
      user: null,
      error: null,
      user: {
        loginEmailAddress: ''
      }
    }
  },
  mixins: [mixins],
  computed: {
    comparePasswords () {
      return this.newpassword != this.confirmPassword ? 'Passwords do not match' : ''
    },
    isComplete() {
      return this.oldpassword && this.newpassword && this.confirmPassword
    }
  },
  async mounted () {
    try {
      const response =  await LoginUserService.showself()
      this.user = response.data
      if(this.user.careGroup) {
        this.groupname = this.user.careGroup.name
      }
      if(this.user.userAccountType) {
        this.accttype = this.user.userAccountType.description
      }
      if(this.user.phone) {
        this.phonenum = this.user.phone.phone
      }
      if(this.user.pager) {
        this.pagernum = this.user.pager.pagerNumber
      }
    } catch (error) {
      this.error = this.handleError(error)
    }
  },
  methods: {
    async chgpwd () {
      try {
        const response = await LoginUserService.chgownpwd({
          oldpassword: this.oldpassword,
          newpassword: this.newpassword
        })
        this.error = 'Change Password Successful'
        this.oldpassword = ''
        this.newpassword = ''
        this.confirmPassword = ''
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'loginUserProfile'
        })
      } catch (error) {
        this.error = this.handleError(error)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LoginUserProfile.vue